module.exports = __webpack_public_path__ + "static/img/english.8a801a54.png";